import type { IconSvgObject } from './types';

const BlendIcon: IconSvgObject = [
  ["circle", { cx: "17", cy: "17", r: "5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 13H3.5C2.67157 13 2 12.3284 2 11.5V3.5C2 2.67157 2.67157 2 3.5 2H11.5C12.3284 2 13 2.67157 13 3.5V7", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.0348 19C9.17734 18.5206 7 16.0355 7 13.0418C7 9.70499 9.70499 7 13.0418 7C16.0355 7 18.5206 9.17734 19 12.0348", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default BlendIcon;
